// @flow
import React, {useCallback, useState} from 'react';
import {Waypoint} from '@homeaway/react-unveil';
import PropertyCarousel from '../PropertyCarousel/PropertyCarousel';
import type {PropertyCardListingShape} from '../PropertyCarousel/PropertyCard/PropertyCard';
import {
    triggerPresentedSerpRecentlyViewedCarouselEvent,
    triggerSelectedSerpCarouselCardEvent,
    triggerPresentedSerpCarouselCardEvent
} from '../../utils/collectionEdapUtils';
import withLingua from '../withLingua/withLingua';
import type {LinguaProps} from '../withLingua/withLingua';
import {DESKTOP_BREAKPOINTS, MOBILE_BREAKPOINTS} from './breakpoints';

import './RecentlyViewedCarousel.less';

type OwnProps = {
    isMobile: boolean,
    listings: PropertyCardListingShape[],
    messages: any,
    position: string
};

type Props = OwnProps & LinguaProps;

export const RecentlyViewedCarousel = (props: Props) => {
    const [waypointEntered, setWaypointEntered] = useState(false);
    const {isMobile, messages, listings, position} = props;
    const title = messages.recentlyViewed;
    const breakpoints = isMobile ? MOBILE_BREAKPOINTS : DESKTOP_BREAKPOINTS;

    const handleWaypointEnter = useCallback(() => {
        if (!waypointEntered) {
            setWaypointEntered(true);
            triggerPresentedSerpRecentlyViewedCarouselEvent(position);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listings, position, waypointEntered]);

    return (
        <Waypoint onEnter={handleWaypointEnter} useWindowAsScrollParent>
            <PropertyCarousel
                isMobile={isMobile}
                title={title}
                breakpoints={breakpoints}
                listings={listings}
                onCardClick={triggerSelectedSerpCarouselCardEvent}
                onCardEnter={triggerPresentedSerpCarouselCardEvent}
            />
        </Waypoint>
    );
};

export default withLingua({
    namespace: 'traveler/search',
    category: 'messages'
})(RecentlyViewedCarousel);
